<template>
    <div id="HomeActivityCarousel">
        <main
            v-if="isMobile"
            id="home-activity-carousel-mobile"
            class="carousel-group"
        >
            <ul class="carousel-card-group">
                <HomeActivityCarouselItem
                    v-for="(item, index) in beachActivities.slice(0, 4)"
                    :key="'carousel-card-' + index"
                    :item="item"
                ></HomeActivityCarouselItem>
            </ul>
        </main>
        <main v-else id="home-activity-carousel-pc">
            <i
                tabindex="0"
                role="button"
                class="icon-left handle"
                @keypress.enter="prevCarouselHandler"
                @click="prevCarouselHandler"
            ></i>
            <div class="carousel-group" id="activity-carousel-group">
                <ul
                    v-for="index in beachActivities.length / 2"
                    :key="'carousel-group-' + index"
                    class="carousel-card-group"
                    :class="{
                        fadeInUp: activatedCarousel === index,
                        fadeOutDown: activatedCarousel !== index,
                    }"
                >
                    <HomeActivityCarouselItem
                        :item="beachActivities[index * 2 - 2]"
                    ></HomeActivityCarouselItem>
                    <HomeActivityCarouselItem
                        :item="beachActivities[index * 2 - 1]"
                    ></HomeActivityCarouselItem>
                </ul>
            </div>
            <i
                tabindex="0"
                role="button"
                class="icon-right handle"
                @keypress.enter="nextCarouselHandler"
                @click="nextCarouselHandler"
            ></i>
        </main>
    </div>
</template>
<script>
export default {
    name: 'HomeActivityCarousel',
}
</script>
<script setup>
import { onMounted, ref, computed } from 'vue'
// import getBeachSearchData from '@/mock/getBeachSearchData'
import { getBeachActivities } from '@/service/apis.js'
import HomeActivityCarouselItem from './HomeActivityCarouselItem.vue'

const isMobile = computed(() => window.innerWidth < 768)
const { beachActivities } = await getBeachActivities()

const activatedCarousel = ref(1)
function nextCarouselHandler() {
    if (activatedCarousel.value === beachActivities.length / 2) {
        activatedCarousel.value = 1
    } else activatedCarousel.value += 1
}
function prevCarouselHandler() {
    if (activatedCarousel.value === 1) {
        activatedCarousel.value = beachActivities.length / 2
    } else activatedCarousel.value -= 1
}

onMounted(() => {
    if (window.innerWidth > 767) {
        let el = document.getElementById('activity-carousel-group')
        el.style.height = el.scrollHeight + 'px'
    }
})
</script>
<style lang="scss" scoped>
i.handle {
    flex: 1 1 120px;

    display: flex;
    align-items: center;
    padding: 0 30px;
    box-sizing: border-box;

    color: $theme1;
    font-size: 100px;

    cursor: pointer;
    transition: 0.3s;

    &.icon-left {
        text-align: right;
    }
    &.icon-right {
        text-align: left;
    }

    &:hover,
    &:focus {
        color: $white;
    }
}

.carousel-group {
    position: relative;
    flex: 0 1 $width2;
    .carousel-card-group {
        width: 100%;
    }
}
#home-activity-carousel-pc {
    display: flex;
    .carousel-card-group {
        display: flex;
        flex-wrap: wrap;
        position: absolute;
        left: 0;
        top: 0;
    }
}
</style>
